export const toLowCaseCleanSpaces = (text) => {
    return String(text || "").toLowerCase().replace(/\s/g, "");
}
export const capitalize = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}